import React from 'react';
import { Outlet } from 'react-router-dom';

import styles from './public-app-v2.module.scss';
import { UserConfig } from 'app/models/user-config';
import { useQueryLanguage } from 'app/hooks/use-query-language';
import logoImage from 'app/components/main-header/logo.png';
import { useTranslation } from 'app/i18n-config';
import { config as appConfig } from 'app/config';
import { TopBar } from 'app/components/top-bar/top-bar';

interface Props {
  config: UserConfig | null;
}

export const PublicPageV2: React.FC<Props> = ({ config }) => {
  const { t } = useTranslation();

  const logoSubtitle = t('public.logoSubtitle');
  const title = t('public.title').split('\n');

  useQueryLanguage();

  return (
    <div className={styles.container}>
      {appConfig.showTopBar && (
        <header className={styles.topBar}>
          <TopBar variant="secondary" />
        </header>
      )}
      <div className={styles.layout}>
        <section className={styles.heroContainer}>
          <div className={styles.hero}>
            <div className={styles.logoContainer}>
              <img src={logoImage} alt="Logo" className={styles.logo} />
              {logoSubtitle && <div className={styles.logoSubtitle}>{logoSubtitle}</div>}
            </div>
            <div className={styles.heroTitle}>
              {title.map((segment, index) => (
                <>
                  {segment}
                  {index < title.length - 1 ? <br /> : null}
                </>
              ))}
            </div>
          </div>
        </section>
        <section className={styles.formArea}>
          <div className={styles.formPanel}>
            <Outlet />
          </div>
        </section>
      </div>
    </div>
  );
};
